// extracted by mini-css-extract-plugin
module.exports = {"root":"MissingInfos_root__zfhyz","iconWrapper":"MissingInfos_iconWrapper__1MeK5","icon":"MissingInfos_icon__1CzH6","textWrapper":"MissingInfos_textWrapper__3E16N"};